export const UPDATE_DASHBOARD_STATE = 'UPDATE_DASHBOARD_STATE'
export const DASHBOARD_SOCKET_DISCONNECT = 'DASHBOARD_SOCKET_DISCONNECT'
export const DASHBOARD_MAKE_SOCKET_CONNECTION = 'DASHBOARD_MAKE_SOCKET_CONNECTION'
export const CALL_DASHBOARD_SOCKET_METHOD = 'CALL_DASHBOARD_SOCKET_METHOD'
export const EMIT_DASHBOARD_CUSTOM_EVENT = 'EMIT_DASHBOARD_CUSTOM_EVENT'
export const LIVE_COUNT_PER_SEC = 'LIVE_COUNT_PER_SEC'
export const LIVE_COUNT_PER_MIN = 'LIVE_COUNT_PER_MIN'
export const UPDATE_ANALYSIS_DATA = 'UPDATE_ANALYSIS_DATA'
